import { OptimizedImage } from '@/shared/ui/OptimizedImage';
import { CenteredContent } from '@/shared/ui/layout/CenteredContent';
import clsx from 'clsx';
import type { SectionWrapperProps } from './SectionWrapper.types';

export const SectionWrapper = ({
  title,
  icon,
  headerAction,
  compact = false,
  className,
  children,
}: SectionWrapperProps) => {
  const contentSpacing = compact ? 'mt-0 mx-0 mb-4' : 'mx-6 my-10';
  const showHeader = title || icon || headerAction;

  return (
    <div className="w-full px-10">
      <CenteredContent className={clsx('border-t border-border pt-5', className)}>
        {showHeader && (
          <header className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 text-body-md font-medium text-foreground">
              {icon && <OptimizedImage src={icon} alt={title ?? ''} width={20} height={20} />}
              {title}
            </div>
            {headerAction}
          </header>
        )}
        <div className={contentSpacing}>{children}</div>
      </CenteredContent>
    </div>
  );
};
